export const DetailRow = ({label, value}) => (
    <div className="flex justify-between text-sm text-slate-300">
        <span>{label}</span>
        <span className="text-white font-medium">{value}</span>
    </div>
);
